export const LogMessageCellRenderer = ({ data }) => {
  if (!data) return <span />;

  const template = data.messageTemplate ?? '';
  const args = data.arguments;
  const argsText = args == null || args === '' ? '' : String(args);

  const parseArgs = (raw) => {
    const trimmed = raw.trim();
    if (trimmed.startsWith('[') && trimmed.endsWith(']')) {
      const inner = trimmed.slice(1, -1).trim();
      if (!inner) return [];
      return inner.split(', ').map((value) => value.trim());
    }
    return [trimmed];
  };

  const injectArgs = (tmpl, rawArgs) => {
    const values = parseArgs(rawArgs);
    if (!values.length) return tmpl;
    let index = 0;
    return tmpl.replace(/\{\}/g, () => {
      const value = values[index];
      index = Math.min(index + 1, values.length);
      return value ?? '';
    });
  };

  if (!template && !argsText) return <span />;
  if (!argsText) return <span>{template}</span>;
  if (!template) return <span>{argsText}</span>;

  const interpolated = template.includes('{}') ? injectArgs(template, argsText) : `${template} ${argsText}`;

  return <span>{interpolated}</span>;
};
